import * as _ from "lodash";
import { userHasRight } from "../../framework";
import { deepClone } from "../../framework/core/core";
import { bind, observable } from "../../framework/core/kendo";
import { emptyFn } from "../../framework/core/util";
import { updateEntity } from "../../framework/dataComponents/updateEntity";
import { Component, Container, PaneIconLink } from "./ui";

var parentEntityName: string;
var parentId: number;
var woopEnabled: boolean;
var selectedWoop: any;

export function cancelSelectedWoop() {
    if (selectedWoop != null) {
        selectedWoop.cancel();
    }
}

export function setWoopEnabled(enabled: boolean, selected: any) {
    woopEnabled = enabled;
    selectedWoop = selected;
}

/*
    * Woop
    * Opens an alert message that looks like GROWL
    *
    *
    * id - ID of the woop created
    * groupContainerID - (optional) use if part of a group of woops
    * observable - the woop's observable used to drive the mouseup method
    * type - the woop type
    * components - the HTML components i.e JSON
    * mouseUp - (optional) the woops custom mouseup method

    */
export function woop(options) {

    options = options || {};
    options.id = options.id;
    options.groupContainerID = options.groupContainerID || null;
    options.observable = options.observable || [];
    options.type = options.type;
    options.insertType = options.insertType || options.type;
    options.components = options.components;
    options.mouseUp = options.mouseUp || null;
    options.expandWoop = options.expandWoop || emptyFn;
    options.insertEntity = options.insertEntity || emptyFn;
    options.failToInsert = options.failToInsert || emptyFn;
    options.insertedSuccessfully = options.insertedSuccessfully || emptyFn;
    options.cancel = options.cancel || emptyFn;
    options.screen = options.screen || options.zScreen || null;
    options.injectButtons = options.injectButtons;
    options.insertObservable = null;
    options.screenEntityType = options.insertType;
    options.requiredRight = options.requiredRight;
    options.rightLocked = options.requiredRight
        ? !userHasRight(options.requiredRight)
        : false;

    var get: (selector: string) => JQuery = $;

    if (options.screen) {
        get = function (selector) { return options.screen.get(selector); };
    }

    if (options.parentId && options.parentEntityName) {
        options.insertObservable = observable({});
        options.insertObservable.set(parentEntityName + "Id", parentId);

        options.setupObservable && options.setupObservable(options.insertObservable);

        options.insertEntity = function () {
            get("#" + options.type + "InsertGroup_Container").mask();
            var dto = deepClone(options.insertObservable);
            if (options.deleteDtoProperties) {
                dto = options.deleteDtoProperties(dto);
            }
            var validator = group.data("kendoValidator");
            validator.options.screenEntityType = options.insertType || options.type;

            var deferred = updateEntity({
                validator: validator,
                dto: dto,
                entityType: options.insertType || options.type,
                friendlyEntityName: options.friendlyEntityName,
                keyField: options.type
            });

            deferred.done(function (args) {
                options.cancel();

                get("#" + options.gridId).data("me").refresh();

                options.insertedSuccessfully(args.response);
            });

            deferred.fail(function () {
                get("#" + options.type + "InsertGroup_Container").unmask();
                options.failToInsert();
            });
        };

        if (!options.rightLocked) {
            options.expandWoop = function () {
                get("#" + (options.groupType || options.type) + "InsertGroup_Container").removeClass("hidden");
                group.removeClass("hidden");
                get("#Insert" + options.type).addClass("selected");

                options.insertObservable = observable({});
                options.insertObservable.set(parentEntityName + "Id", parentId);

                options.setupObservable && options.setupObservable(options.insertObservable);

                bind({ container: group, bind: ".bind-value", data: options.insertObservable });
            };

            options.cancel = function () {
                bind({ container: group, bind: ".bind-value", unbind: true });

                group.find("input.bind-value").val("");
                group.find(".validation-failure").removeClass("validation-failure");

                get("#" + (options.groupType || options.type) + "InsertGroup_Container").addClass("hidden");
                group.addClass("hidden");
                get("#Insert" + options.type).removeClass("selected");
                get("#" + options.type + "InsertGroup_Container").unmask();
            };
        }
    }

    var group;

    if (options.groupContainerID != null) {
        if (options.groupContainerID.indexOf("#") != -1) {
            group = $(options.groupContainerID);
        } else {
            group = $("#" + options.groupContainerID);
        }
    } else if (options.screen) {
        if (options.groupType) {
            group = options.screen.get("#Insert" + (options.typeAlias || options.type) + "Container");
        } else {
            group = options.screen.get("#" + (options.typeAlias || options.type) + "InsertGroup_Container");
        }
    } else {
        if (options.groupType) {
            group = $("#Insert" + (options.typeAlias || options.type) + "Container");
        } else {
            group = $("#" + (options.typeAlias || options.type) + "InsertGroup_Container");
        }
    }

    if (options.components) {
        var woopView: Component;
        if (options.injectButtons) {
            var buttons = new Container({
                classes: "accept-cancel-container",
                components: [
                    new PaneIconLink({
                        id: "Insert" + options.type + "Button",
                        iconClass: "check",
                        toolTip: "Insert" + options.type
                    }),
                    new PaneIconLink({
                        id: "CancelInsert" + options.type,
                        iconClass: "cancel",
                        toolTip: "Cancel" + options.type
                    })
                ]
            });

            woopView = options.components(buttons);
        } else {
            woopView = options.components();
        }
        woopView.options.zScreen = options.screen || {};
        woopView.options.screenEntityType = options.screenEntityType;

        woopView.render(group);
    }

    if (options.groupType) {
        get("#" + options.groupType + "InsertGroup_Container").children().addClass("hidden");
    }

    group.zValidator();

    if (!options.rightLocked) {
        get("#" + options.id).tie("click", function () {
            if (selectedWoop != null) {
                selectedWoop.cancel();
            }
            options.expandWoop();
            woopEnabled = true;
            selectedWoop = options;
        });

        $("#Main").on("keydown", function (e) {
            if (woopEnabled == true && selectedWoop && selectedWoop.type == options.type) {
                if (e.keyCode == 13) {
                    // when the auto complete is being used this will return if the item was just selected from auto complete
                    if (e.target.attributes["data-role"] &&
                        e.target.attributes["data-role"].value == "autocomplete"
                        && ($(e.target).data("kendoAutoComplete") as any).popup._closing) {
                        return;
                    }
                    $(document.activeElement).trigger("blur");
                    options.insertEntity();
                    woopEnabled = false;
                } else if (e.keyCode == 27) {
                    options.cancel();
                    woopEnabled = false;
                }
            }
        });

        get("#Insert" + (options.typeAlias || options.type) + "Button").bind("click", function () {
            options.insertEntity();
            woopEnabled = false;
        });

        get("#CancelInsert" + (options.typeAlias || options.type)).bind("click", function () {
            options.cancel();
            woopEnabled = false;
        });

        $("#Main").mouseup(function (e) {
            if (selectedWoop != null) {
                if (selectedWoop.type == options.type && woopEnabled == true) {
                    var handleMouseUp = false,
                        elem = get("#" + (options.typeAlias || options.type) + "InsertGroup_Container");

                    if (!elem.is(e.target) && elem.has(e.target).length == 0) {
                        handleMouseUp = true;
                    }

                    if (handleMouseUp == true) {
                        if (options.mouseUp) {
                            options.mouseUp();
                            woopEnabled = false;
                        } else if (options.observable.length > 0) {
                            var woopObservable = options.observable();
                            if (woopObservable && woopObservable.dirty) {
                                options.insertEntity();
                            } else {
                                options.cancel();
                            }
                            woopEnabled = false;
                        }
                    }
                }
            }
        });
    }
}
